<template>
  <div :class="`toolbar__${position}`" class="grid-x grid-padding-x">
    <template v-if="position === 'top'">
      <div class="small-12 cell hide-for-small-only" v-html="pageProductCount" />
      <div class="small-12 cell show-for-small-only">
        <span class="off-canvas__filter_toggle _button _secondary _small" data-toggle="offCanvas-filter">{{ $t('Filter') }}</span>
      </div>
      <div class="small-12 cell">
        <div class="catalog__category-sort">
          <list-sort-select :data-source="dataSource"></list-sort-select>
        </div>
      </div>
    </template>
    <div class="small-24 cell" v-if="position === 'bottom'">
      <list-paginator :data-source="dataSource"></list-paginator>
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';
  import ServiceContainer from '@flashpointbv/solar-service-container';

  @Component({
    name: 'product-list-toolbar',
    components: {
      'list-paginator': ServiceContainer().getComponent('catalog-product-list-toolbar-paginator'),
      'list-sort-select': ServiceContainer().getComponent('catalog-product-list-toolbar-sort-select'),
      'top-filter-list': ServiceContainer().getComponent('catalog-product-top-filter-list')
    }
  })

  export default class extends Vue {
    @Prop({required: true}) readonly dataSource: string;
    @Prop({required: true}) readonly position: string;

    private get pageProductCount(): string {
      const fromProducts = this.$store.getters[`${this.dataSource}/currentPage`] > 1 ? (((this.$store.getters[`${this.dataSource}/pageSize`] * this.$store.getters[`${this.dataSource}/currentPage`]) + 1) - this.$store.getters[`${this.dataSource}/pageSize`]) : 1;
      const toProducts = (this.$store.getters[`${this.dataSource}/pageSize`] * this.$store.getters[`${this.dataSource}/currentPage`]) > this.$store.getters[`${this.dataSource}/totalItemCount`] ? this.$store.getters[`${this.dataSource}/totalItemCount`] : (this.$store.getters[`${this.dataSource}/pageSize`] * this.$store.getters[`${this.dataSource}/currentPage`]);
      return this.$tc('<span class="show-for-between-medium-small">{fromProducts} tot {toProducts} van {totalProductCount} resultaten</span><span class="hide-for-between-medium-small">{fromProducts}-{toProducts} van {totalProductCount}</span>', this.totalProductCount, {fromProducts: fromProducts, toProducts: toProducts, totalProductCount: this.totalProductCount});
    }

    get currentPage(): number {
      return Number(this.$store.getters[`${this.dataSource}/currentPage`]);
    }

    private get totalProductCount(): number {
      return this.$store.getters[`${this.dataSource}/totalItemCount`];
    }
  }
</script>
